import { useCallback } from 'react';
import debounce from 'lodash/debounce';

export function useDebounceFn(func, time = 50, opts = {}, deps = []) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useCallback(debounce(func, time, opts), deps);
}
